import { RouteObject } from "react-router-dom";
import {
  MANAGE_USERS_AND_BUYERS,
  MANAGE_USERS_AND_BUYERS_COMPANY,
  MANAGE_USERS_AND_BUYERS_OVERVIEW,
  MANAGE_USERS_AND_BUYERS_COMPANY_TOP_CUSTOMER,
  MANAGE_USERS_AND_BUYERS_SUBSCRIPTION,
} from "constants/urls";

export default [
  {
    path: MANAGE_USERS_AND_BUYERS,
    lazy: () => import("./routes/ManageUsersAndBuyersLinkList"),
  },
  {
    path: MANAGE_USERS_AND_BUYERS_OVERVIEW,
    lazy: () => import("./routes/ManageUsersAndBuyersOverview"),
  },
  {
    path: MANAGE_USERS_AND_BUYERS_COMPANY,
    lazy: () => import("./routes/ManageUsersAndBuyersCompany"),
  },
  {
    path: MANAGE_USERS_AND_BUYERS_COMPANY_TOP_CUSTOMER,
    lazy: () => import("./routes/ManageUsersAndBuyersTopCustomer"),
  },
  {
    path: MANAGE_USERS_AND_BUYERS_SUBSCRIPTION,
    lazy: () => import("./routes/ManageUsersAndBuyersSubscription"),
  },
] as RouteObject[];
